import styled from "styled-components"

export const Layout = styled.footer`
  background: white;
`
